import createReduxFieldValidator from './createReduxFieldValidator';
import { VALIDATE_USERNAME_PATH } from '../../../shared/endpoints/account';

const asyncValidate = createReduxFieldValidator(
    'username',
    VALIDATE_USERNAME_PATH
);

export default asyncValidate;
